import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { FuseConfigService } from '../../../../../@fuse/services/config.service';
import { GT2FormPageAbstract } from '../../../../gt2/content/abstract/GT2FormPageAbstract';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { FuseTranslationLoaderService } from '../../../../../@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { NGXLogger } from 'ngx-logger';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { AppRoutesService } from '../../../../gt2/services/app-routes.service';
import { SupportContactService } from '../../../../gt2/content/contact/support-contact.service';
import { locale as english } from './i18n/en-CA';
import { locale as french } from './i18n/fr-CA';
import { Settings } from '../../../../gt2/settings/settings';
import { AppRoutes } from '../../../../gt2/const/AppRoutes';
import { GenericAlertComponent } from '../../../../gt2/components/generic-alert/generic-alert.component';
import { JwtInterceptor } from '../../../../gt2/interceptors/JwtInterceptor';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'error-404',
  templateUrl: './error-404.component.html',
  styleUrls: ['./error-404.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class Error404Component
  extends GT2FormPageAbstract
  implements OnInit, AfterViewInit, OnDestroy
{
  form: UntypedFormGroup | any;
  subject?: string;
  message?: string;
  successEmail: boolean = false;
  last404URL?: string | null = null;
  readonly environment = environment;
  /*
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private router: Router,
    public location: Location,
    private translationLoader: FuseTranslationLoaderService,
    public translate: TranslateService,

    public dialog: MatDialog,
    private logger: NGXLogger,
    private formBuilder: UntypedFormBuilder,
    public appRoutesService: AppRoutesService,
    private titleService: Title,
    private supportContactService: SupportContactService,
  ) {
    super();
    this.translationLoader.loadTranslations(english, french);

    if (JwtInterceptor.LAST_URL_404) {
      this.last404URL = JwtInterceptor.LAST_URL_404;
    }

    // Configure the layout
    this._fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };

    //
    this.form = this.formBuilder.group({
      subject: [
        '',
        [
          Validators.minLength(Settings.inputMinChar),
          Validators.maxLength(Settings.inputMaxCharMid),
          Validators.required,
        ],
      ],
      message: [
        '',
        [Validators.minLength(Settings.inputMinChar), Validators.required],
      ],
    });

  }

  ngOnInit() {
    //this.titleService.setTitle(this.translate.instant("GENERIC.ERROR"));
  }
  public onOpenInNewTab(item: any): void {
    window.open(item, '_blank');
  }
  ngAfterViewInit() {}

  ngOnDestroy() {}

  public onSendContactForm(): void {
    //this.logger.info("Error404Component.onSendContactForm()");
    if (this.last404URL) {
      this.message +=
        ' - (url: ' +
        this.last404URL +
        '  version:' +
        environment.appVersion +
        ')';
      // this.logger.info("&&&&&&& -> " + this.message);
    }

    const email: any = {
      subject: '(Error 404 page) ' + this.subject,
      message: this.message,
    };
    this.supportContactService.postEmailError404(email).subscribe({
      next: (response) => {
        // this.logger.info("Error404Component.onSendContactForm() -> SUCCESS: " + JSON.stringify(response));
        // this.successEmail = true;
        this.showConfirmationDialog();
      },
      error: (error) => {
        this.logger.error(
          'Error404Component.onSendContactForm() -> ERROR: ' +
            JSON.stringify(error),
        );
      },
    });
  }

  public override onPageBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      const prefix = (localStorage.getItem('PREFIX') || '') + '/';
      this.router.navigateByUrl(prefix + AppRoutes.EVENTS);
    }
  }

  public onVisitGt2(): void {
    window.open('https://www.gestiontraiteur.com', '_blank');
  }

  public showConfirmationDialog(): void {
    this.subject = '';
    this.message = '';
    this.form.markAsUntouched();
    this.form.markAsPristine();

    this.dialogRef = this.dialog.open(GenericAlertComponent, {
      // width: '45%',
      disableClose: false,
    });
    this.dialogRef.componentInstance.alertTitle = '';
    this.dialogRef.componentInstance.alertMessage = this.translate.instant(
      'ERROR_404.SUCCESS_MESSAGE',
    );
    // this.dialogRef.componentInstance.showConfirmButton = false;

    this.dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        this.dialogRef = null;
      },
    });
  }
}
